import React from 'react';
import {
    setValuesAction as setConfiguratorValuesAction,
    showTyreIndexAction
} from '../../_flux/actions/catalog_configurator_actions';
import { getDefaultValueForFilter } from '../../_flux/helper/filters/get_default_value_for_filter';
import { CHECK_ORDER } from './check_order';
import { types } from '../../_constants/product/types';

export function resetFiltersAfterFilter(lastFilterNotToBeResetted, tyreType) {
    const lastFilterNotToBeResettedCheckOrderIndex = CHECK_ORDER.indexOf(lastFilterNotToBeResetted);

    if (lastFilterNotToBeResettedCheckOrderIndex === -1) {
        return;
    }

    //hack.. should be removed once there are enough moto tyres
    if (tyreType === types.TYRE_MOTO && lastFilterNotToBeResettedCheckOrderIndex < 2) {
        showTyreIndexAction();
    }

    const filtersToReset = CHECK_ORDER.slice(lastFilterNotToBeResettedCheckOrderIndex + 1);
    const actionPayload = filtersToReset.reduce((accumulator, currentValue) => {
        accumulator[currentValue] = getDefaultValueForFilter(currentValue);
        return accumulator;
    }, {});

    setConfiguratorValuesAction(actionPayload);
}

export function resetAllFilter(tyreType) {
    if ([types.TYRE_CAR, types.TYRE_MOTO].indexOf(tyreType) === -1) {
        return;
    }

    const actionPayload = CHECK_ORDER.reduce((accumulator, currentValue) => {
        accumulator[currentValue] = getDefaultValueForFilter(currentValue);
        return accumulator;
    }, {});

    setConfiguratorValuesAction(actionPayload);
}
